
<template>
  <div class="mains">
    <div class="leftC">
      <div ref="refLeftTopHeight">
        <a-row style="border: 1px solid #e8eaec; padding: 5px;">
          <a-col>
            <a-button size="small" class="mg5" @click="query">{{$t('job.Query')}}</a-button>
            <a-button size="small" class="mg5" @click="reset">{{$t('job.Reset')}}</a-button>
            <a-button size="small" class="mg5" @click="deleteTimer">{{$t('job.Delete')}}</a-button>
            <a-button size="small" class="mg5" @click="setStatus('ENABLE')">{{$t('job.Activate')}}</a-button>
            <a-button size="small" class="mg5" @click="setStatus('DISABLE')">{{$t('job.Inactivate')}}</a-button>
            <a-button size="small" class="mg5" @click="run">{{$t('job.Run')}}</a-button>
          </a-col>
        </a-row>
        <a-row style="padding: 10px 0; padding-left: 50px;">
          <a-form :form="formQuery">
            <a-col :span="6">
              <a-form-item>
                <b>{{$t('job.Action')}}</b>
                <a-input size="small" v-decorator="['jobName']" @pressEnter="query" style="width: 100%;"/>
              </a-form-item>
            </a-col>
            <a-col :span="6" :offset="1">
              <a-form-item>
                <b>{{$t('job.Status')}}</b>
                <a-select size="small" v-decorator="['status']" style="width: 100%;">
                  <a-select-option v-for="item in theStatus" :key="item.value" :value="item.value">
                    {{item.title}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-form>
        </a-row>
        <a-row>
          <a-col align="right" style="margin: 5px 0;">
            <a-pagination
                :pageSizeOptions="pageSizeOptions"
                :showTotal="total => $t('job.Total') + ` ${pagingTotal} `+$t('job.Records')"
                size="small"
                :total="pagingTotal"
                v-model="currentVal"
                :pageSize.sync="pagingSize"
                @change="tableChangePage"
                @showSizeChange="onShowSizeChange"
                :showSizeChanger="showSizeChanger"
                :showQuickJumper="showQuickJumper"
            />
          </a-col>
        </a-row>
      </div>
      <div class="table-container">
        <vxe-table
            border
            resizable
            stripe
            column-key
            highlight-hover-column
            highlight-hover-row
            highlightCurrentRow
            show-header-overflow
            show-overflow
            @cell-dblclick="editDetail"
            :sort-config="{multiple: true, trigger: 'cell'}"
            :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
            keep-source
            :keyboard-config="{isArrow: true}"
            :checkbox-config="{trigger: 'row', highlight: true, range: true}"
            align="center"
            :data.sync="PagingGridList"
            class="mytable-style"
            :height="getLeftHeight"
            ref="refLeftPagingGrid"
            size="mini">
          <template v-slot:empty>
            <a-empty></a-empty>
          </template>
          <vxe-table-column type="checkbox" width="35"></vxe-table-column>
          <vxe-table-column field="uid" title="UID" show-header-overflow="ellipsis" show-overflow="title" :visible="false"></vxe-table-column>
          <vxe-table-column field="jobName" :title="$t('job.Action')" width="300px" sortable></vxe-table-column>
          <vxe-table-column field="expression" :title="$t('job.Expression')" width="130px" sortable></vxe-table-column>
          <vxe-table-column field="schedName" :title="$t('job.BusinessType')" width="300px" sortable></vxe-table-column>
          <vxe-table-column field="status" :title="$t('job.Status')" width="100px" sortable><template v-slot="{row}">{{row.status | filterSatus}}</template></vxe-table-column>
          <vxe-table-column field="startTime" :title="$t('job.StartTime')" :formatter="formatTime" width="130px" sortable></vxe-table-column>
          <vxe-table-column field="triggerStatus" :title="$t('job.TriggerStatus')" width="120px" sortable><template v-slot="{row}">{{row.triggerStatus | filterTriggerStatus}}</template></vxe-table-column>
          <vxe-table-column field="prevFireTime" :title="$t('job.PrevFireTime')" width="150px" sortable></vxe-table-column>
          <vxe-table-column field="nextFireTime" :title="$t('job.NextFireTime')" width="150px" sortable></vxe-table-column>
        </vxe-table>
      </div>
    </div>

    <div class="rightC">
      <a-row style="border: 1px solid #e8eaec;">
        <a-button size="small" class="mg5" @click="add">{{$t('job.Add')}}</a-button>
        <a-button size="small" class="mg5" @click="saveDetail">{{$t('job.Save')}}</a-button>
      </a-row>
      <a-row>
        <a-form :form="formSave">
          <a-row>
            <a-col :span = "12">
              <a-form-item class="genericFrom" v-show="false">
                <a-input v-decorator="[
                                                        'uid',
                                                        {
                                                            initialValue: this.jobTimer == null ? '' : this.jobTimer.uid
                                                        }]
                                                    "/>
              </a-form-item>
              <a-form-item  class="genericFrom">
                <b>{{$t('job.Expression')}}<span style="color: red">*</span></b>
                <a-input size="small" :disabled="true" v-decorator="[
                                                                        'cronExpression',
                                                                        {
                                                                            initialValue: this.jobTimer == null ? '' : this.jobTimer.cronExpression,
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <b>{{$t('job.ActionNo')}}<span style="color: red">*</span></b>
                <a-input-search size="small" style="width: 100%;" @search="searchAction" v-decorator="[
                                                                        'jobDetailUid',
                                                                        {
                                                                            initialValue: this.jobTimer == null ? '' : this.jobTimer.jobDetailUid,
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span = "12">
              <a-form-item class="genericFrom">
                <b>{{$t('job.Status')}}</b>
                <a-select size="small" :disabled="true" v-decorator="[
                                                        'status',
                                                        {
                                                            initialValue: this.jobTimer == null ? '' : this.jobTimer.status
                                                        }]
                                                    ">
                  <a-select-option v-for="item in theStatus" :key="item.value" :value="item.value">
                    {{item.title}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <b>{{$t('job.BusinessType')}}</b>
                <a-input size="small" v-decorator="[
                                                    'schedName',
                                                    {
                                                        initialValue: this.jobTimer == null ? '' : this.jobTimer.schedName
                                                    }]"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item>
                <b>{{$t('job.StartTime')}}</b><br>
                <a-date-picker size="small" format="YYYY-MM-DD HH:mm" show-time class="custom-date-picker" v-decorator="[
                                                        'startTime',
                                                        {
                                                            initialValue: this.jobTimer == null ? '' : this.jobTimer.startTime
                                                        }]"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <b>{{$t('job.TriggerStatus')}}</b>
                <a-input size="small" :disabled="true" :value="getTriggerStatusDisplay()" />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item>
                <b>{{$t('job.PrevFireTime')}}</b>
                <a-input size="small" :disabled="true" :value="jobTimer ? jobTimer.prevFireTime : ''" />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item>
                <b>{{$t('job.NextFireTime')}}</b>
                <a-input size="small" :disabled="true" :value="jobTimer ? jobTimer.nextFireTime : ''" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-row>
      <a-row style="border: 1px solid #e8eaec;margin-top: 5px;">
        <a-button size="small" class="mg5" @click="createExpression">{{$t('job.CreateExpression')}}</a-button>
        <a-button size="small" class="mg5" @click="resetExpression">{{$t('job.Reset')}}</a-button>
      </a-row>
      <a-row style="margin-top: 20px;">
        <a-radio-group v-model="isInput" style="width: 100%">
          <a-row>
            <a-col span="10" offset="3">
              <a-radio :value="0">{{$t('job.Expression')}}</a-radio>
            </a-col>
            <a-col span="10">
              <a-radio :value="1">{{$t('job.DateTime')}}</a-radio>
            </a-col>
          </a-row>
        </a-radio-group>
      </a-row>
      <a-form :form="formExpression" style="margin-top: 40px;">
        <a-row v-if="isInput == 0">
          <a-col :span="13" offset="3">
            <a-form-item>
              <a-input size="small" v-decorator="[
                                                                        'expression',
                                                                        {
                                                                            initialValue: '00 00 09 * * ? *',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row v-else>
          <a-row>
            <a-col :span="4" offset="3">
              <a-form-item>
                <b>{{$t('job.Year')}}: </b>
                <a-input size="small" :maxLength = "4" v-decorator="[
                                                                        'year',
                                                                        {
                                                                            initialValue:'*',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
            <a-col :span="4" offset="3">
              <a-form-item>
                <b>{{$t('job.Month')}}: </b>
                <a-input size="small" :maxLength = "2" v-decorator="[
                                                                        'month',
                                                                        {
                                                                            initialValue:'*',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
            <a-col :span="4" offset="3">
              <a-form-item>
                <b>{{$t('job.Day')}}: </b>
                <a-input size="small" :maxLength = "2" v-decorator="[
                                                                        'day',
                                                                        {
                                                                            initialValue:'*',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4" offset="3">
              <a-form-item>
                <b>{{$t('job.Hour')}}: </b>
                <a-input size="small" :maxLength = "2" v-decorator="[
                                                                        'hour',
                                                                        {
                                                                            initialValue:'*',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
            <a-col :span="4" offset="3">
              <a-form-item>
                <b>{{$t('job.Minute')}}: </b>
                <a-input size="small" :maxLength = "2" v-decorator="[
                                                                        'minute',
                                                                        {
                                                                            initialValue:'*',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
            <a-col :span="4" offset="3">
              <a-form-item>
                <b>{{$t('job.Second')}}: </b>
                <a-input size="small" :maxLength = "2" v-decorator="[
                                                                        'second',
                                                                        {
                                                                            initialValue:'00',
                                                                            rules: [
                                                                                {
                                                                                  required: true,
                                                                                  message: $t('publicLang.Required'),
                                                                                }
                                                                            ]
                                                                        }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-row>
      </a-form>
    </div>

    <search-action ref="queryWindow" @checkedCode="checkedCode"></search-action>
  </div>
</template>

<script>
import ajax from "../../api/ajax";
import api from "../../api/url";
import XEUtils from "xe-utils";
import searchAction from "./components/searchAction";
import moment from "moment";
import cookie from '../../api/cookie';

let that;
export default{
  components:{
    searchAction
  },
  data(){
    return{
      pagingTotal: 0,
      pagingSize:  20,
      currentVal: 1,
      showSizeChanger:true,
      showQuickJumper:false,
      pageSizeOptions:['10', '20', '30', '40','100','200','500','1000'],
      PagingGridList: [],
      jobTimer:null,
      formQuery: this.$form.createForm(this, {}),
      formSave: this.$form.createForm(this, {}),
      formExpression: this.$form.createForm(this, {}),
      leftTopHeight: 0,
      isInput:0,
      theStatus:[
        {title:'',value:''},
        {title:this.$t('job.Add'),value:"ADD"},
        {title:this.$t('job.Activate'),value:"ENABLE"},
        {title:this.$t('job.Inactivate'),value:"DISABLE"},
      ],
      mode: 'datetime',
    }
  },
  created() {
    this.query();
    that = this;
  },
  mounted() {
    this.leftTopHeight = this.$refs.refLeftTopHeight.clientHeight;

    // 添加窗口大小变化监听器
    this.handleResize = () => {
      this.$nextTick(() => {
        if (this.$refs.refLeftTopHeight) {
          this.leftTopHeight = this.$refs.refLeftTopHeight.clientHeight;
        }
        // 强制更新表格高度
        if (this.$refs.refLeftPagingGrid) {
          this.$refs.refLeftPagingGrid.recalculate();
        }
      });
    };

    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    // 清理事件监听器
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
  },
  computed:{
    getLeftHeight(){
      // 使用更精确的高度计算，避免出现双滚动条
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const topHeight = this.leftTopHeight || 0;
      const padding = 120; // 增加一些缓冲空间
      return Math.max(300, windowHeight - topHeight - padding); // 最小高度300px
    }
  },
  filters: {
    filterSatus(val) {
      let sta = that.theStatus;
      for(let i in sta){
        if(val == sta[i].value){
          return sta[i].title
        }
      }
    },
    filterTriggerStatus(val) {
      if (!val) return '-';
      const statusMap = {
        'WAITING': 'Waiting',
        'ACQUIRED': 'Acquired',
        'EXECUTING': 'Executing',
        'COMPLETE': 'Complete',
        'BLOCKED': 'Blocked',
        'ERROR': 'Error',
        'PAUSED': 'Paused',
        'PAUSED_BLOCKED': 'Paused Blocked'
      };
      return statusMap[val] || val;
    }
  },
  methods:{
    query(){
      this.resetDetail()
      this.formQuery.validateFields((err, values) => {
        if(err){
          this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
          return;
        }
        if(values){
          let params = {
            jobName : values.jobName,
            status : values.status,
            currentVal : (this.currentVal - 1) * this.pagingSize,
            pagingSize : this.pagingSize,
          }
          ajax.get(api.TIMERLIST,params).then(res=>{
            if(res.code == 200){
              this.PagingGridList = res.data;
              this.pagingTotal = res.total;

              // 确保表格在数据更新后重新计算高度
              this.$nextTick(() => {
                if (this.$refs.refLeftPagingGrid) {
                  this.$refs.refLeftPagingGrid.recalculate();
                }
              });
            }
          })
        }
      });
    },
    cleardata(){
      this.reset();
    },
    reset(){
      this.formQuery.resetFields();
    },
    resetDetail(){
      this.formSave.resetFields();
      this.jobTimer = null
      this.resetExpression()
    },
    resetExpression(){
      this.formExpression.resetFields();
    },
    deleteTimer(){
      let Records = this.$refs.refLeftPagingGrid.getCheckboxRecords()
      if(Records.length == 0){
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
        return;
      }
      let uidList = [];
      for(let i in Records){
        if(Records[i].status == 'ENABLE'){
          this.$customMessage.warning(this.$t('job.StatusCanNotDel'), 2);
          return;
        }
        uidList.push(Records[i].uid)
      }
      let that = this;
      this.$customConfirm({
        title: this.$t('pubGicSet.AreyoudeleTask'),
        okText: this.$t('publicLang.Confirm'),
        cancelText: this.$t('publicLang.Cancel'),
        content: "",
        onOk() {
          let params = new FormData();
          params.append("uidList", uidList);
          ajax.post(api.DELETETIMER, params).then(res => {
            if (res.code == 200) {
              that.query()
              that.$message.success(that.$t("publicLang.DeleteSuccess"));
            } else {
              that.$customMessage.error(res.msg);
            }
          })
        }
      });
    },
    run(){
      let Records = this.$refs.refLeftPagingGrid.getCheckboxRecords()
      if(Records.length == 0){
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
        return;
      }else if(Records.length > 1){
        this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 2);
        return;
      }

      let params = {
        uid: Records[0].uid
      }

      ajax.get(api.RUN,params).then(res=>{
        if (res.code == 200) {
          this.query()
          this.$message.success(res.msg)
        } else {
          this.$customMessage.warning(res.msg);
        }
      })


    },
    setStatus(val){
      let Records = this.$refs.refLeftPagingGrid.getCheckboxRecords()
      if(Records.length == 0){
        this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 2);
        return;
      }
      let uidList = [];
      for(let i in Records){
        if(Records[i].status == val){
          continue
        }
        uidList.push(Records[i].uid)
      }
      if(uidList.length == 0){
        return;
      }
      let params = new FormData();
      params.append("uidList", uidList);
      params.append("status", val);
      ajax.post(api.SETTIMERSTATUS, params).then(res => {
        if (res.code == 200) {
          this.query()
          this.$message.success(res.msg)
        } else {
          this.$customMessage.warning(res.msg);
        }
      })
    },
    add(){
      this.formSave.resetFields()
      this.jobTimer = null
      this.formSave.setFieldsValue({
        status: 'ADD',
        startTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      });
    },
    tableChangePage(current) {
      this.currentVal = current;
      this.query();
    },
    onShowSizeChange(current, pageSize) {
      this.currentVal = current;
      this.pagingSize = pageSize;
      this.query();
    },
    editDetail({ row }) {
      let params = {
        uid: row.uid
      }
      ajax.get(api.GETTIMER,params).then(res=>{
        this.formSave.resetFields();
        this.jobTimer = res.data;
        if(this.isInput == 0){
          this.formExpression.setFieldsValue({
            expression: this.jobTimer.cronExpression
          });
        }
      })
    },
    saveDetail(){
      this.formSave.validateFields((err, values) => {
        if(err){
          this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
          return;
        }
        if(values){
          if(values.cronExpression.length == 0 || values.jobDetailUid.length == 0){
            this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
            return;
          }
          if(values.status == null || values.status.length == 0){
            let addStatus = 'ADD'
            values.status = addStatus
            this.formSave.setFieldsValue({
              status: addStatus
            });
          }
          if(values.startTime == null || values.startTime.length == 0){
            let startT = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
            values.startTime = startT
            this.formSave.setFieldsValue({
              startTime: startT
            });
          }else{
            values.startTime = moment(values.startTime).format('YYYY-MM-DD HH:mm:ss')
          }
          ajax.post(api.TIMERSAVE, values).then(res => {
            if (res.code == 200) {
              this.query()
              this.resetDetail()
              this.$message.success(res.msg,2)
            } else {
              this.$customMessage.warning(res.msg,2);
            }
          })
        }
      });
    },
    createExpression(){
      this.formExpression.validateFields((err, values) => {
        if(err){
          this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
          return;
        }
        if(values){
          let newExpression;
          if(this.isInput == 0){
            if(values.expression == null || values.expression.length == 0){
              this.$customMessage.warning(this.$t('publicLang.InputRequiredValue'), 2);
              return;
            }
            newExpression = values.expression
          }else{
            newExpression = values.second + " " + values.minute + " " + values.hour + " " + values.day + " " + values.month + " ? " + values.year
          }
          this.formSave.setFieldsValue({
            cronExpression: newExpression
          });
        }
      });
    },
    formatTime ({cellValue}) {
      return XEUtils.toDateString(cellValue, 'yyyy-MM-dd HH:ss')
    },
    searchAction(){
      let no = ''
      this.formSave.validateFields((err, values) => {
        if(values){
          no = values.jobDetailUid
        }
      });
      this.$refs.queryWindow.show(no)
    },
    checkedCode(row) {
      let name = ''
      if(row != null){
        name = row.jobName
      }
      this.formSave.setFieldsValue({
        jobDetailUid: name
      });
    },
    getTriggerStatusDisplay() {
      if (!this.jobTimer || !this.jobTimer.triggerStatus) return '';
      const statusMap = {
        'WAITING': 'Waiting',
        'ACQUIRED': 'Acquired',
        'EXECUTING': 'Executing',
        'COMPLETE': 'Complete',
        'BLOCKED': 'Blocked',
        'ERROR': 'Error',
        'PAUSED': 'Paused',
        'PAUSED_BLOCKED': 'Paused Blocked'
      };
      return statusMap[this.jobTimer.triggerStatus] || this.jobTimer.triggerStatus;
    }
  }
}
</script>

<style lang="less">
.mains{
  height: 100vh;
  width: 100%;
  background-color: white;
  display: flex;
  overflow: hidden;
}

.leftC{
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-right: 10px;
  min-width: 0;
}

.table-container {
  flex: 1;
  overflow: hidden;
  min-height: 0;
  position: relative;
}

.table-container .vxe-table {
  height: 100% !important;
}

.table-container .vxe-table .vxe-table--body-wrapper {
  overflow-x: auto !important;
  overflow-y: auto !important;
}

/* 确保vxe-table内部滚动条正常工作 */
.table-container .vxe-table--main-wrapper {
  overflow: hidden !important;
}

.table-container .vxe-table--body {
  overflow: visible !important;
}

/* 隐藏可能出现的额外滚动条 */
.table-container::-webkit-scrollbar {
  display: none;
}

.table-container {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.rightC{
  width: 400px;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border-left: 1px solid #e8eaec;
  padding-left: 10px;
  flex-shrink: 0;
  position: relative;
}

.rightC::before {
  content: '';
  position: absolute;
  left: -1px;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: #e8eaec;
  z-index: 1;
}

.rightC .ant-col:first-child {
  padding-right: 8px;
}

.rightC .ant-col:last-child {
  padding-left: 8px;
}

.rightC .ant-date-picker,
.rightC .custom-date-picker {
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
}

.rightC .ant-date-picker .ant-input,
.rightC .custom-date-picker .ant-input {
  width: 100% !important;
  box-sizing: border-box !important;
  padding-right: 30px !important;
}

.rightC .ant-form-item .ant-input,
.rightC .ant-form-item .ant-select,
.rightC .ant-form-item .ant-date-picker {
  width: 100% !important;
  box-sizing: border-box !important;
}

.marginTop{
  margin-top: 3px;
}
</style>
